import React, { useEffect } from 'react';
import RouteConstants from '../../constants/routeConstants';
import { useState, Downgraded } from '@hookstate/core';
import { useHistory, generatePath } from 'react-router-dom';
import Helper from '../../utility/helper';
import { Box, Paper, CircularProgress } from '@mui/material';
import Title from '../../sharedcomponents/title/title';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import DataList from './dataList/dataList';

const NotesUser = () => {
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');
    const gAgentInfo=Helper.getSessionStorage('agentUser');
    const agentConnection = Helper.getSessionStorage('agentConnections');

    const allData = useState([]);
    const loading = useState(false);
    // const [modPermission] = React.useState('FULL');
    const history = useHistory();

    useEffect(() => {
        getNotes();
    }, []);

    const getNotes = () => {
        loading.set(true);
        let activityData = [];
        ApiHelper.get(
            APIURLConstants.GET_NOTES_USER(eventInfo.eventID, agentConnection && gAgentInfo? gAgentInfo.userID: userInfo.userID)
        )
            .then((res) => {
                if (res.data.length > 0) {
                    res.data.map((item) => {
                        if (item.notesStatus === 1) {
                            activityData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'notes',
                                        key: 'notes',
                                        notes: item.notesID,
                                        showNotes: true,
                                        width: '0.05',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'title',
                                        key: 'title',
                                        title: item.title,
                                        showLabel: false,
                                        titleRedirect: true,
                                        width: '0.95',
                                        inColumn: true,
                                        showDetails: true,
                                        createdDate:
                                            Helper.FormatDate(
                                                item.createdDate
                                            ) +
                                            ' @ ' +
                                            Helper.FormatTime(item.createdDate),
                                        createdBy: item.createdByName,
                                    },
                                ],
                                selected: false,
                            });
                        }
                    });
                } else {
                    activityData = [];
                }

                loading.set(false);
            })
            .catch((err) => {
                console.log(err);
                loading.set(false);
            });

        allData.set(activityData);
    };

    const handleViewNotes = (notes, event) => {
        event.preventDefault();
        event.stopPropagation();
        let path = generatePath(RouteConstants.EVENT_NOTES_DETAILS, {
            eventID: eventInfo.eventID,
        });
        history.push({
            pathname: path,
            state: { notes: notes.actualData },
        });
    };

    return (
        <Box
            sx={{
                p: '16px',
                width: '100%',
            }}>
            <Title title={'Notes'} />
            {loading.get() ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                        marginTop: '15%',
                    }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box sx={{ marginTop: '-8px' }}>
                    <Paper sx={{ width: '100%', boxShadow: 'none' }}>
                        <DataList
                            showSearch={true}
                            // modPermission={modPermission}
                            data={allData.attach(Downgraded).get()}
                            handleViewNotes={handleViewNotes}
                            hideAdd={true}
                        />
                    </Paper>
                </Box>
            )}
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.EVENT_NOTES_USER,
        component: NotesUser,
    },
    name: 'NotesUser',
};
